import React, { useState, useEffect } from 'react'
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux'

import { sendLogin } from "../actions";
import md5 from 'md5';

const Login = () => {
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const usuario = useSelector((state) => state.usuario)
	const [user, setUser] = useState({
			user: "",
			pass: ""
		})
	
	useEffect(() => {
		if (localStorage.getItem("isAuthenticate"))  navigate("/", { replace: true })
	},[])

	useEffect(() => {
		if (usuario.user && localStorage.getItem("isAuthenticate"))  navigate("/", { replace: true })
	})

	const cambia = (key, value) => {
		setUser({...user, [key]: value });
	};

	const enviaLogin = e => {
		if (user.user == "") {
			this.setState({ msj: "COMPLETE YOUR USER" });
		} else if (user.pass == "") {
			this.setState({ msj: "COMPLETE YOUR PASSWORD" });
		} else {
			var data = {
				user: user.user,
				pass: md5(user.pass)
			}
			console.log(data)
			dispatch(sendLogin(data))
		}
	};

		return (
			<div className="row bg_naranja justify-content-center align-items-center" style={{ height: "100vh" }}>
				<form className='text-center' style={{ maxWidth: "400px" }} id="form_dark">
					<img src="./imgs/isologo_concept.png" alt="Believe" className="pb-4" style={{ width: "150px" }} />
					<div className="form-group">
						<label className='white'>User</label>
						<input
							type="text"
							className="form-control  tuneado"
							id="user"
							aria-describedby="emailHelp"
							placeholder="Ingrese el usuario"
							value={user.user}
							onChange={(evt) => cambia("user", evt.target.value)}
						/>
					</div>
					<div className="form-group">
						<label className='white'>Password</label>
						<input type="password" className="form-control  tuneado" id="pass" placeholder="Ingrese el password" value={user.pass} onChange={(evt) => cambia("pass", evt.target.value)} />
					</div>
					<button type="button" className="btn  btn-outline-light tuneado mt-2 w-100" onClick={enviaLogin}>
						LOGIN
					</button>
					
				</form>
			</div>
		);
	
};
/*
const mapStateToProps = (state, ownProps) => {
	return {
		usuario: state.usuario
	}
}

const mapDispatchToProps = dispatch => {
	return {
		sendLogin: (datos) => {
			dispatch(sendLogin(datos));
		},
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Login)
*/

export default Login;
